import { computed, ref } from "vue";

export const useValidationErrors = () => {
    const validationErrors = ref({});

    const setValidationErrors = (value) => {
        const merge = (target, source) => {
            const output = { ...target };
            if (isObject(target) && isObject(source)) {
                Object.keys(source).forEach(key => {
                    if (isObject(source[key])) {
                        if (!(key in target)) {
                            Object.assign(output, { [key]: source[key] });
                        } else {
                            output[key] = merge(target[key], source[key]);
                        }
                    } else {
                        Object.assign(output, { [key]: source[key] });
                    }
                });
            }
            return output;
        };

        const isObject = (item) => {
            return (item && typeof item === 'object' && !Array.isArray(item));
        }

        validationErrors.value = merge(validationErrors.value, value);
    }

    const resetValidationErrors = () => {
        validationErrors.value = {}
    }

    const hasValidationErrors = computed(() => Object.keys(validationErrors.value).length > 0);

    const getValidationErrors = (key = null) => {
        const errors = key ? validationErrors.value[key] : validationErrors.value
        
        if (errors === undefined || errors === null) {
            return []
        }

        if (typeof errors === 'object' && !Array.isArray(errors)) {
            return errors
        }

        return Array.isArray(errors) ? errors : [errors]
    }

    return {
        validationErrors,
        setValidationErrors,
        resetValidationErrors,
        hasValidationErrors,
        getValidationErrors
    }
}
